import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort, } from '../../../shared/utility';
import { baseLogoImg, chenthoorLandscapeLogo, lightningHandLogo, shamalAzzourLogo, ministryLogo, newKuwaitLogo, boldArabicFont, securityStamp, securityPositionFalah, securitySignatureFalah, securityPositionAnezi, securitySignatureAnezi, securityPositionJaseer, securitySignatureJaseer } from '../../../shared/fontsAndBitImages';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import AZNLogo from '../../../assets/images/AZN LOGO .jpg';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import lodash from 'lodash';


const Inputs = ({ field, metaData, onInputChange, type, ...props }) => {
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && <Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={Object.assign({}, metaData)}
    /> || null;

}


const PartyType = [{ label: "Outlet", value: "Outlet" }, { label: "Vendor", value: "Vendor" }]

const PURCHASE_RETURN_ID = '2AE4D864-B447-4F37-86EF-2C34626E3B6D';

class AddPurchaseReturn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: '',
            month: '',
            year: '',
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            payslipGenerated: false,
            stageSequence: 0,
            month: false,
            year: false,
            requestDate: moment(),
            requestedFor: false,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            popupType: 'submit',
            requestattachments: [],
            partyType: null,
        }
        this.handleContainer = this.handleContainer.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }


    // for new data table
    textEditor = (options) => {
        return (
            <InputText
                type="text"
                value={options.value}
                onChange={(e) =>
                    options.editorCallback(e.target.value)
                }
            />
        );
    };

    onCellEditComplete = (e) => {
        let { rowData, newValue, field } = e;

        rowData[field] = newValue;

        this.setState({
            containerTable: [...this.state.containerTable]
        });

        console.log("Updated Row:", rowData);
    };

    //----------

    handleChange = (e, el) => {
        e.preventDefault();
        const { name, value } = e.target;

        if (el.fieldDescription === 'Party Type') {
            this.setState({ partyType: value });
        }

        this.setState({
            process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue: field.fieldName === name ? value : field.fieldValue })) }))
        });
        this.setState({ payslipGenerated: false })


    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet, childRowNmbr) {

        try {
            const { stageSequence } = this.state;

            const updatedProcess = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr ? valueToBeSet : field.fieldValue })
                    })
            }))

            return updatedProcess
        }
        catch (error) {
            this.setState({ error: error })
        }
    }

    handleContainer = (field) => {
        try {
            this.setState({ loading: true, ifaddupdatepressed: 1 });
            const { process, stageSequence } = this.state;
            const { location } = this.props;
            let cldr = field.childRowNmbr;
            let flag = 0;
            let vcategory = '';

            let kwdtotalAmount = parseFloat(0.000).toFixed(3);

            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    if (el.fieldDescription === 'Description' && (el.fieldValue === "0" || el.fieldValue === "")) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'please enter description' });
                        flag = 1;
                        return;
                    }
                    if (el.fieldDescription === 'Category') {
                        vcategory = el.fieldValue;

                    }
                    if (el.fieldDescription === 'Family Members' && el.fieldValue === null && (vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F14BA' || vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F13BA')) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Family Member' });
                        flag = 1;
                        return;
                    }
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: parseFloat(el.fieldValue)
                }));
            });

            if (flag === 1) return;

            let totalAmount = parseFloat(0.000);
            let j;
            for (j = 0; j < dummy[0].length; j++) {
                totalAmount += parseFloat(dummy[0][j].amount)
            }

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount : (el.fieldDescription == 'Hotel Expense') ? 0 :
                                    (el.fieldDescription == 'Transportation Expense') ? 0 : (el.fieldDescription == 'Meals Expense') ? 0 : (el.fieldDescription == 'Purchases Expense') ? 0 : (el.fieldDescription == 'Other Expenses') ? 0 : '') : (el.fieldDescription == 'Exchange Rate') ? 0 : null
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });
            j = 0;

            //  const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldId("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount)

            const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldidrownum("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount, cldr)


            // InitialValues =InitialValues.filter((p, i) => i = 0 ).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))




            //dummy.forEach(subData => kwdtotalAmount += subData.amount);
            // let totalAmount = 0.000.toFixed(3);
            //     let i ;
            //     for(i=0; i < dummy[0].length; i++){
            //         totalAmount = parseFloat(totalAmount) + dummy[0][i].amount
            //     }
            // kwdtotalAmount = dummy && +parseFloat(dummy[0][0].amount).toFixed(3);
            //: (field.childRowNmbr == editedRowNumber && field.fieldDescription === 'Total Amount in KWD' && totalAmount ) ? totalAmount 


            setTimeout(() => {
                try {

                    if (error) {
                        this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                        return;
                    }

                    this.setState({ loading: false, process: initialValuesWithUpdatedTotal });

                    //this.setState({ loading: false });
                    //this.setState({ loading: false, process: InitialValues });
                    //this.setState({ loading: false }, { process: process });

                }

                catch (error) {
                    //handleExpectedError(error);
                    this.setState({ error: error });
                }

            }, 3000);

        }

        catch (error) {
            //handleExpectedError(error);
            this.setState({ error: error });
        }

        //i = 0;

        // this.setState({
        //     process: this.state.process.filter((p,i) => i <= 20  ).map(stage => Object.assign({}, { ...stage }, {
        //         stage_Field: stage
        //             .stage_Field.map(field => {
        //                 return Object.assign({}, { ...field }, { fieldValue:  field.fieldDescription === 'Total Amount in KWD' && totalAmount ? totalAmount  : field.fieldValue })
        //             })
        //     }))
        // });


        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))
        // });
    }

    handleAttachment = (data, type) => {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return {
                Requestattachmentid: '00000000-0000-0000-0000-000000000000',
                Requestid: '00000000-0000-0000-0000-000000000000',
                SiNo: index,
                UploadPath: el.filePath,
                FileName: el.fileName,
                Extension: el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID,
                Createddate: moment().format('MM/DD/YYYY'),
                Updatedby: this.props.loggedUserDetail.empID,
                Updateddate: moment().format('MM/DD/YYYY'),
                CompanyId: this.props.loggedUserDetail.CompanyId,
                Stagenum: 0,
            }
        });
        this.setState({ requestattachments: attachmentData });
    }

    initialize = (process, type, field) => {
        const { tableLists, location = {} } = this.props;
        const { stageSequence } = this.state;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const pageType = this.props.match.params.type;
        const pendingWith = location && location.state && location.state.pendingWith


        let count = 1;
        let sequence = 1;
        if (type === 'progress' || type === 'add' || type === 'edit') {
            this.setState({ process: [], loading: true });

            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                return Object.assign({}, { ...stage }, {
                    stage_Field: stageField.reduce((a, el) => {
                        const startIndex = el.fieldName.substring(0, 10);
                        if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                        } else if (type === 'add' && el.fieldType === '9') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                            const lastItem = a[a.length - 1];
                            fields.map((subField) => {
                                a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                            })
                        } else if (type === 'edit') {
                            a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            const lastItem = a[a.length - 1];
                            if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                el.stage_FieldsList.map((subField, subIndex) => {
                                    if (subIndex != 0) {
                                        subField.stage_FieldsListc2.map(c2 => {
                                            a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                        })
                                    }
                                })
                            }
                        }
                        return a;
                    }, [])
                })
            });

            setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
        } else {

            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }

    }

    generatePayslip = (type) => {
        this.setState({ loading: true });
        this.handlePayslipInPdf(type);
    }

    // Resolves ID/value to its corresponding Label for PDF display.
    resolveFieldDisplayValue = (field) => {
        const { metaData = {} } = this.props;

        if (!field) {
            return '';
        }

        const fieldValue = field.fieldValue;

        if (fieldValue == null || fieldValue === '') {
            return '';
        }

        // Find dropdown options for the current field. Supplier fields are keyed under
        // "Preferred Supplier" in metaData regardless of the form's own field label
        // (e.g. "Select Supplier"), so fall back to that list when the exact
        // fieldDescription key isn't present.
        let options = metaData[field.fieldDescription] || [];
        if (options.length === 0 && /supplier/i.test(field.fieldDescription || '')) {
            options = metaData['Preferred Supplier'] || metaData['Select Supplier'] || [];
        }

        // Match against value/id/uniqueId, case-insensitively, since Supplier (and other
        // GUID-keyed) dropdown options may carry the matching identifier under any of these
        // depending on how the keyword list was built, and casing can differ between the
        // saved fieldValue and the option's own identifier.
        const matchedOption = options.find(option => {
            if (!option) return false;
            return (
                String(option.value != null ? option.value : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.id != null ? option.id : '').toLowerCase() === String(fieldValue).toLowerCase() ||
                String(option.uniqueId != null ? option.uniqueId : '').toLowerCase() === String(fieldValue).toLowerCase()
            );
        });

        if (matchedOption) {
            return matchedOption.label || matchedOption.text || matchedOption.name || fieldValue;
        }

        // Date fields
        if (field.fieldType === '7' || field.fieldType === '8') {
            return moment(fieldValue).format('DD/MM/YYYY');
        }

        return fieldValue;
    };

    resolveEmployeeLabel = (employeeId) => {
        if (employeeId == null || employeeId === '') {
            return '';
        }

        const {
            metaData = {},
            loggedUserDetail = {},
            Employee = []
        } = this.props;

        // Combine all possible employee lists
        const employeeOptions = [
            ...(metaData['Request For'] || []),
            ...(metaData['Requested For'] || []),
            ...(Employee || [])
        ];

        // Find employee using value / id / uniqueId
        const employee = employeeOptions.find(option => {
            if (!option) return false;

            return (
                String(option.value || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.id || '').toLowerCase() === String(employeeId).toLowerCase() ||
                String(option.uniqueId || '').toLowerCase() === String(employeeId).toLowerCase()
            );
        });

        if (employee) {
            return (
                employee.label ||
                employee.text ||
                employee.name ||
                employee.userName ||
                employee.employeeName ||
                employeeId
            );
        }

        // Fallback for logged-in employee
        if (
            loggedUserDetail.empID &&
            String(loggedUserDetail.empID).toLowerCase() === String(employeeId).toLowerCase()
        ) {
            return loggedUserDetail.userName || employeeId;
        }

        // If no matching employee found
        return employeeId;
    };

    handlePayslipInPdf = (type) => {
        try {
            const { process } = this.state;
            const { location = {}, tableLists = {}, loggedUserDetail = {}, containerData } = this.props;
            const { state = {} } = location;

            // Full stage list (reached stages + any stages not yet reached/approved), same
            // concat convention already used by this component's own polling logic, so
            // pending stages are included instead of being structurally absent from `process`.
            const templateStages =
                (containerData &&
                    Object.keys(containerData).length > 0 &&
                    containerData.stage) || [];

            let fullProcess = [];

            if (
                tableLists &&
                Array.isArray(tableLists.requestAttribute1) &&
                tableLists.requestAttribute1.length > 0
            ) {
                // Use complete workflow data for Approval History
                fullProcess = tableLists.requestAttribute1;
            } else if (Array.isArray(process) && process.length > 0) {
                // Fallback for Add/New record
                fullProcess = process.concat(
                    templateStages.filter(
                        (c, i) => i > (process.length - 1)
                    )
                );
            } else {
                fullProcess = templateStages;
            }
            // Header fields: top-level (non-container) fields across every completed stage.
            // The same field (e.g. "Party", "Payment Type", "Payment Mode", "Comment") is repeated on every
            // stage's stage_Field list, so dedupe by fieldDescription (via a Map, which preserves first-seen
            // column order) instead of concatenating every stage's copy - concatenating produced a duplicate
            // column/row for each field that appears on more than one stage.
            const headerFieldsMap = new Map();
            process.forEach(stage => {
                (stage.stage_Field || [])
                    .filter(field => field.parentFieldId === '000' && field.fieldType !== '9')
                    .forEach(field => {
                        // Later stages hold the most up-to-date value for the same field.
                        headerFieldsMap.set(field.fieldDescription, field);
                    });
            });
            const headerFields = Array.from(headerFieldsMap.values());

            // Line items: fieldType '9' containers, grouped by childRowNmbr (same grouping used on-screen), excluding the trailing in-progress row.
            // Purchase Return has multiple containers (Item, Service Charges), each rendered under its own heading
            // instead of being merged into one combined "Line Items" section.
            // let lineItemSections = [];
            // process.forEach(stage => {
            //     (stage.stage_Field || []).filter(field => field.fieldType === '9').forEach(containerField => {
            //         const groupFields = (stage.stage_Field || []).filter(field => field.parentFieldId === containerField.fieldName);
            //         const grouped = lodash.groupBy(groupFields, 'childRowNmbr');
            //         const rowKeys = Object.keys(grouped);
            //         const committedRowKeys = rowKeys.filter((key, i) => i !== rowKeys.length - 1);
            //         if (committedRowKeys.length === 0) { return; }

            //         const columnFields = grouped[rowKeys[rowKeys.length - 1]] || grouped[committedRowKeys[0]] || [];

            //         // Some containers' raw fieldDescription is shorter than the heading we want in the PDF
            //         // (e.g. the Service Charges container is described simply as "Service" in the form data).
            //         const sectionTitleMap = { 'Service': 'Service Charges' };
            //         const sectionTitle = sectionTitleMap[containerField.fieldDescription] || containerField.fieldDescription;

            //         let section = lineItemSections.find(s => s.title === sectionTitle);
            //         if (!section) {
            //             section = {
            //                 title: sectionTitle,
            //                 columns: columnFields.map(field => field.fieldDescription),
            //                 rows: []
            //             };
            //             lineItemSections.push(section);
            //         }

            //         committedRowKeys.forEach(key => {
            //             const row = grouped[key];
            //             section.rows.push(columnFields.map(colField => {
            //                 const match = row.find(r => r.fieldDescription === colField.fieldDescription);
            //                 return match ? this.resolveFieldDisplayValue(match) : '';
            //             }));
            //         });
            //     });
            // });

            // ============================================================
            // PURCHASE RETURN PDF - ITEM / SERVICE CHARGES SECTIONS
            // ============================================================

            const lineItemSections = [];

            /**
             * Convert container description to the required PDF heading.
             */
            const getSectionTitle = (containerField) => {
                const description = (containerField.fieldDescription || '').trim();

                if (/^item$/i.test(description)) {
                    return 'Item';
                }

                if (/^service$/i.test(description) ||
                    /^service charges$/i.test(description)) {
                    return 'Service Charges';
                }

                return description;
            };


            /**
             * Check whether a container row contains actual data.
             * Do NOT remove the last row blindly.
             */
            const hasRowData = (rowFields = []) => {
                return rowFields.some(field => {
                    const value = field && field.fieldValue;

                    if (value === null || value === undefined) {
                        return false;
                    }

                    if (Array.isArray(value)) {
                        return value.length > 0;
                    }

                    return String(value).trim() !== '';
                });
            };


            process.forEach(stage => {

                const stageFields = stage.stage_Field || [];

                // Find all container fields
                const containerFields = stageFields.filter(
                    field => field.fieldType === '9'
                );

                containerFields.forEach(containerField => {

                    const sectionTitle = getSectionTitle(containerField);

                    // Only Purchase Return Item / Service containers
                    if (
                        sectionTitle !== 'Item' &&
                        sectionTitle !== 'Service Charges'
                    ) {
                        return;
                    }

                    // Get all fields belonging to this container
                    const childFields = stageFields.filter(
                        field =>
                            field.parentFieldId === containerField.fieldName
                    );

                    if (childFields.length === 0) {
                        return;
                    }

                    // Group fields by row number
                    const groupedRows = lodash.groupBy(
                        childFields,
                        field => field.childRowNmbr
                    );

                    const rowKeys = Object.keys(groupedRows);

                    // ----------------------------------------------------
                    // IMPORTANT:
                    // Do not remove the last row automatically.
                    // Remove only completely empty rows.
                    // ----------------------------------------------------
                    const validRowKeys = rowKeys.filter(rowKey => {
                        const rowFields = groupedRows[rowKey];

                        return hasRowData(rowFields);
                    });

                    // Get fields for column structure.
                    // Use the first valid row.
                    const firstValidRow =
                        validRowKeys.length > 0
                            ? groupedRows[validRowKeys[0]]
                            : childFields;

                    // Remove duplicate column names
                    const uniqueColumns = [];

                    firstValidRow.forEach(field => {

                        const columnName = field.fieldDescription;

                        if (
                            columnName &&
                            !uniqueColumns.includes(columnName)
                        ) {
                            uniqueColumns.push(columnName);
                        }
                    });

                    // Create section only once
                    let section = lineItemSections.find(
                        item => item.title === sectionTitle
                    );

                    if (!section) {

                        section = {
                            title: sectionTitle,
                            columns: uniqueColumns,
                            rows: []
                        };

                        lineItemSections.push(section);
                    }

                    // ----------------------------------------------------
                    // Map every valid row to this section
                    // ----------------------------------------------------
                    validRowKeys.forEach(rowKey => {

                        const rowFields = groupedRows[rowKey];

                        const rowData = section.columns.map(columnName => {

                            const field = rowFields.find(
                                rowField =>
                                    rowField.fieldDescription === columnName
                            );

                            if (!field) {
                                return '';
                            }

                            return this.resolveFieldDisplayValue(field);
                        });

                        // Add only rows containing actual values
                        if (
                            rowData.some(
                                value =>
                                    value !== null &&
                                    value !== undefined &&
                                    String(value).trim() !== ''
                            )
                        ) {
                            section.rows.push(rowData);
                        }
                    });
                });
            });


            // ============================================================
            // FORCE THE REQUIRED PURCHASE RETURN SECTION ORDER
            // ============================================================

            const requiredSectionOrder = [
                'Item',
                'Service Charges'
            ];

            const orderedLineItemSections = [];

            requiredSectionOrder.forEach(sectionName => {

                const existingSection = lineItemSections.find(
                    section => section.title === sectionName
                );

                if (existingSection) {
                    orderedLineItemSections.push(existingSection);
                } else {
                    // Create an empty section so that the PDF
                    // always has the required container.
                    orderedLineItemSections.push({
                        title: sectionName,
                        columns: [],
                        rows: []
                    });
                }
            });

            lineItemSections.length = 0;
            orderedLineItemSections.forEach(section => {
                lineItemSections.push(section);
            });

            // Approval History: parsed from each subsequent stage's description (skips the initial/request stage,
            // i.e. Stage 0, which always reads "Pending" since it is never included here). Each stage's own
            // description is the single source of truth for that stage's approval details - "Employee Number: X,
            // Employee Name: Y, Position: Z, Date: <date>" - and it only carries a populated date segment once
            // that specific stage has actually been approved, so a stage reads "Pending" until its own
            // description says otherwise, and switches to its real date the moment that happens - no separate
            // stage-progress index is layered on top to second-guess it.
            const processArray = fullProcess.slice(1);

            const approvalHistoryRows = [];

            processArray.forEach((item, index) => {
                let employeeNumber = '';
                let employeeName = '';
                let position = '';
                let dateAndTime = 'Pending';

                const description = item.description || '';

                if (description && description.includes(',')) {

                    const parts = description
                        .split(',')
                        .map(part => part.trim());

                    // Employee Number
                    employeeNumber = (parts[0] || '')
                        .replace(/^[^:]+:\s*/, '')
                        .trim();

                    // Employee Name
                    employeeName = ((parts[1] || '')
                        .split('-')[0] || '')
                        .trim();

                    // Position
                    position = (parts[2] || '').trim();

                    // Date & Time - some descriptions carry an extra "Status: Approval" segment before the
                    // actual date (so the date isn't reliably at a fixed index), so find the segment whose
                    // label actually mentions "date" instead of assuming it's always parts[3].
                    const dateSegment = parts.find(part => /^[^:]*date[^:]*:/i.test(part));
                    const parsedDateAndTime = (dateSegment || '')
                        .replace(/^[^:]+:\s*/, '')
                        .trim();

                    if (parsedDateAndTime) {
                        const parsedMoment = moment(parsedDateAndTime, [
                            moment.ISO_8601,
                            'MM/DD/YYYY HH:mm:ss',
                            'MM/DD/YYYY hh:mm A',
                            'DD/MM/YYYY HH:mm:ss',
                            'DD/MM/YYYY hh:mm A',
                            'DD-MMM-YYYY hh:mm A'
                        ], true);

                        dateAndTime = parsedMoment.isValid()
                            ? parsedMoment.format('DD-MMM-YYYY hh:mm A')
                            : parsedDateAndTime;
                    }
                }

                approvalHistoryRows.push([
                    index + 1,
                    employeeNumber,
                    employeeName,
                    position,
                    dateAndTime
                ]);
            });

            const requestNum = state.requestNum || (tableLists && tableLists.requestNum) || 'PurchaseReturn';

            // Request For: convert Employee ID to Employee Label/Name.
            const requestedForField = headerFields.find(
                field =>
                    field.fieldDescription === 'Requested For' ||
                    field.fieldDescription === 'Request For'
            );

            const requestedFor = requestedForField
                ? this.resolveEmployeeLabel(requestedForField.fieldValue)
                : '';

            // Created By must always match the Request For name shown elsewhere in the PDF.
            const createdBy = requestedFor;

            const printedBy = (loggedUserDetail && (loggedUserDetail.userName || loggedUserDetail.empID)) || '';
            const printedOn = moment().format('DD/MM/YYYY HH:mm');

            // Voucher Details laid out as one row (Request Num + every header field), same structure as Line Items
            const headerColumns = ['Request Num', ...headerFields.map(field => field.fieldDescription)];

            const headerValues = [
                requestNum,
                ...headerFields.map(field => {
                    if (
                        field.fieldDescription === 'Request For' ||
                        field.fieldDescription === 'Requested For'
                    ) {
                        return this.resolveEmployeeLabel(field.fieldValue);
                    }

                    return this.resolveFieldDisplayValue(field);
                })
            ];
            var doc = new jsPDF('p', 'mm', 'a4', 3);

            doc.autoTable({
                theme: 'plain',
                didDrawCell: function (data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        doc.addImage(chenthoorLandscapeLogo, 'PNG', data.cell.x, data.cell.y - 3, 40, 20);
                    }
                },
                startY: 9,
                margin: { left: 8.5 },
                columnStyles: { 0: { cellWidth: 50 }, 1: { cellWidth: 200 } },
                body: [[
                    { content: "", styles: { cellPadding: 0, borderColor: 'white' } },
                    { content: "CHENTHOOR RESTAURANT", styles: { halign: 'left', valign: 'middle', fontStyle: 'bold', fontSize: 14, textColor: 'black', cellPadding: { top: 5, left: 6, right: 0 }, borderColor: 'white' } }
                ]]
            });

            let previousTableEnding = doc.lastAutoTable.finalY;

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 10,
                margin: { left: 5 },
                tableWidth: 200,
                body: [[]]
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            doc.setFontSize(12);
            doc.text('Purchase Return Details:', 5, previousTableEnding + 14);

            // Split Voucher Details across two rows: first half of fields, then the remaining half
            const headerMidpoint = Math.ceil(headerColumns.length / 2);
            const headerColumnsRow1 = headerColumns.slice(0, headerMidpoint);
            const headerValuesRow1 = headerValues.slice(0, headerMidpoint);
            const headerColumnsRow2 = headerColumns.slice(headerMidpoint);
            const headerValuesRow2 = headerValues.slice(headerMidpoint);

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 18,
                styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                alternateRowStyles: { fillColor: [255, 255, 255] },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.1,
                margin: { left: 5 },
                tableWidth: 200,
                head: [headerColumnsRow1],
                body: [headerValuesRow1],
            });

            previousTableEnding = doc.lastAutoTable.finalY;

            if (headerColumnsRow2.length > 0) {
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [headerColumnsRow2],
                    body: [headerValuesRow2],
                });

                previousTableEnding = doc.lastAutoTable.finalY;
            }

            // lineItemSections.forEach(section => {
            //     if (section.rows.length === 0) { return; }
            //     doc.setFontSize(12);
            //     doc.text(`${section.title}:`, 5, previousTableEnding + 14);
            //     doc.autoTable({
            //         theme: 'grid',
            //         startY: previousTableEnding + 18,
            //         styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
            //         headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
            //         bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
            //         alternateRowStyles: { fillColor: [255, 255, 255] },
            //         tableLineColor: [0, 0, 0],
            //         tableLineWidth: 0.1,
            //         margin: { left: 5 },
            //         tableWidth: 200,
            //         head: [section.columns],
            //         body: section.rows,
            //     });
            //     previousTableEnding = doc.lastAutoTable.finalY;
            // });

            // ============================================================
            // ITEM + SERVICE CHARGES PDF SECTIONS
            // ============================================================

            lineItemSections.forEach(section => {

                doc.setFontSize(12);

                // Section heading
                doc.text(
                    `${section.title}:`,
                    5,
                    previousTableEnding + 14
                );

                // If there is no data, still create a separate container
                if (
                    !section.columns ||
                    section.columns.length === 0
                ) {

                    doc.autoTable({
                        theme: 'grid',
                        startY: previousTableEnding + 18,
                        margin: { left: 5 },
                        tableWidth: 200,
                        styles: {
                            halign: 'center',
                            fontSize: 8,
                            cellPadding: 3
                        },
                        headStyles: {
                            fillColor: [255, 255, 255],
                            textColor: [0, 0, 0],
                            lineColor: [0, 0, 0]
                        },
                        bodyStyles: {
                            fillColor: [255, 255, 255],
                            textColor: [0, 0, 0],
                            lineColor: [0, 0, 0]
                        },
                        tableLineColor: [0, 0, 0],
                        tableLineWidth: 0.1,
                        body: [
                            [
                                {
                                    content: 'No records found',
                                    colSpan: 1,
                                    styles: {
                                        halign: 'center'
                                    }
                                }
                            ]
                        ]
                    });

                } else {

                    doc.autoTable({
                        theme: 'grid',
                        startY: previousTableEnding + 18,
                        styles: {
                            halign: 'center',
                            fontSize: 8,
                            cellPadding: 3
                        },
                        headStyles: {
                            fillColor: [255, 255, 255],
                            textColor: [0, 0, 0],
                            lineColor: [0, 0, 0]
                        },
                        bodyStyles: {
                            fillColor: [255, 255, 255],
                            textColor: [0, 0, 0],
                            lineColor: [0, 0, 0]
                        },
                        alternateRowStyles: {
                            fillColor: [255, 255, 255]
                        },
                        tableLineColor: [0, 0, 0],
                        tableLineWidth: 0.1,
                        margin: { left: 5 },
                        tableWidth: 200,

                        head: [section.columns],

                        body:
                            section.rows.length > 0
                                ? section.rows
                                : [
                                    section.columns.map(
                                        () => ''
                                    )
                                ]
                    });
                }

                previousTableEnding =
                    doc.lastAutoTable.finalY;
            });

            if (approvalHistoryRows.length > 0) {
                doc.setFontSize(12);
                doc.text('Approval History:', 5, previousTableEnding + 14);
                doc.autoTable({
                    theme: 'grid',
                    startY: previousTableEnding + 18,
                    styles: { halign: 'center', fontSize: 8, cellPadding: 3 },
                    headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    bodyStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0] },
                    alternateRowStyles: { fillColor: [255, 255, 255] },
                    tableLineColor: [0, 0, 0],
                    tableLineWidth: 0.1,
                    margin: { left: 5 },
                    tableWidth: 200,
                    head: [['S.No', 'Employee Number', 'Employee Name', 'Position', 'Date & Time']], body: approvalHistoryRows,
                });
                previousTableEnding = doc.lastAutoTable.finalY;
            }

            // Footer (Created By / Printed By / Printed On) is added to every page below
            const totalPages = doc.internal.getNumberOfPages();
            for (let pageIndex = 1; pageIndex <= totalPages; pageIndex++) {
                doc.setPage(pageIndex);
                doc.setFontSize(8);
                doc.setTextColor(0, 0, 0);
                doc.text(`Created By: ${createdBy}     Printed By: ${printedBy}     Printed On: ${printedOn}`, 5, 292);
            }

            if (type === 'print') {
                doc.autoPrint();
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'view') {
                window.open(doc.output('bloburl'), requestNum);
                this.setState({ loading: false, payslipGenerated: true });
            } else if (type === 'download') {
                doc.save(`${requestNum}.pdf`);
                this.setState({ loading: false, payslipGenerated: true });
            }
        } catch (error) {
            this.setState({ loading: false });
            this.growl.show({ severity: 'error', summary: null, detail: 'Failed to generate PDF' });
        }
    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process } = this.state;
        const type = this.props.match.params.type;
        let requestNumber = (this.props.location && this.props.location.state && this.props.location.state.requestNum) || '';
        let loggedUserEmpId = this.props.loggedUserDetail.empID;


        let RequestAttributes = [];
        let Comment = '';
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                if (el.fieldDescription === 'Comment' && stageIndex === 0) {
                    Comment = el.fieldValue;
                }
                //         if(el.fieldDescription === 'Expense Type' && stageIndex === 0){
                //             RequestType = el.fieldValue;
                //         }

                RequestAttributes.push(Object.assign({}, { ...el }, {
                    fieldValue: (el.fieldType === "7" || el.fieldType === "8")
                        ? moment(el.fieldValue).format('MM/DD/YYYY')
                        : (el.fieldType === "3")
                            ? (Array.isArray(el.fieldValue) ? el.fieldValue.join(',') : (typeof el.fieldValue === 'string' && el.fieldValue ? el.fieldValue : ''))
                            : el.fieldValue
                }));
            })
        });

        // if(!RequestType){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Expense Type before Submitting/Saving' });
        //     return;
        // }


        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Purchase Return Request',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
            ProcessID: PURCHASE_RETURN_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'EACTIVITY';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'EACTIVITY';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'EACTIVITY';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
            }


            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            // if(requestNumber && submitType == 'submit'){//checking whether the request is in the requester stage or approver stage
            //     // let generatedPdf = this.handlePayslipInPdf('upload', loggedUserEmpId.toUpperCase());
            //     axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            //         .then(response => {
            //             if(response.status == 200){
            //                 axios.post(url, JSON.stringify(datas))// triggering the submit/save of a request
            //                     .then(response => {
            //                         this.setState({ loading: false });
            //                         if (submitType === 'submit' || submitType === 'return') {
            //                             if (response.status === 200) {
            //                                 if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
            //                                     let submitValue = response.data.result && JSON.parse(response.data.result);
            //                                     let tableValue = [];
            //                                     if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
            //                                         tableValue = submitValue.Table.map(list => {
            //                                             return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
            //                                         })
            //                                     }
            //                                     if(submitType === 'submit'){
            //                                         this.setState({dialogBoxText: "Select Supervisor"})
            //                                     }
            //                                     if(submitType === 'return'){
            //                                         this.setState({dialogBoxText: "Return To", popupType:'return'})
            //                                     }
            //                                     this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
            //                                 } else {
            //                                     this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass In Request submitted successfully' });
            //                                     this.props.history.push('/dashboard');
            //                                 }
            //                             } else {
            //                                 this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                             }

            //                         } else {
            //                             this.growl.show({ severity: 'success', summary: null, detail: 'Material Pass In Request saved successfully' });
            //                             this.props.history.push('/dashboard');
            //                         }

            //                     })
            //                     .catch(err => {
            //                         this.setState({ loading: false })
            //                         this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
            //                     })
            //             }

            //         }).catch(err => {
            //             this.growl.show({ severity: 'error', summary: null, detail: 'File Upload API Failed. Please Approve again' });
            //             this.setState({ loading: false });
            //         })
            // } else {
            {
                axios.post(url, JSON.stringify(datas))
                    .then(response => {

                        this.setState({ loading: false });
                        if (submitType === 'submit' || submitType === 'return') {
                            if (response.status === 200) {
                                if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                    let submitValue = response.data.result && JSON.parse(response.data.result);
                                    let tableValue = [];
                                    if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                        tableValue = submitValue.Table.map(list => {
                                            return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO, Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID }
                                        })
                                    }
                                    if (submitType === 'submit') {
                                        this.setState({ dialogBoxText: "Select Supervisor" })
                                    }
                                    if (submitType === 'return') {
                                        this.setState({ dialogBoxText: "Return To", popupType: 'return' })
                                    }
                                    this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                                } else {
                                    this.growl.show({ severity: 'success', summary: null, detail: 'Purchase Return Request submitted successfully' });
                                    this.props.history.push('/dashboard');
                                }
                            } else {
                                this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                            }

                        } else {
                            this.growl.show({ severity: 'success', summary: null, detail: 'Purchase Return Request saved successfully' });
                            this.props.history.push('/dashboard');
                        }

                    })
                    .catch(err => {
                        this.setState({ loading: false })
                        this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                    })
            }

        }

    }

    componentDidMount() {
        const { getContainerData, getKeywordValues, getMasterKeywordList, location = {}, loggedUserDetail } = this.props;
        const type = this.props.match.params.type;
        // this.effectiveDateHandler()
        getContainerData(PURCHASE_RETURN_ID);//Get Container Data
        getKeywordValues('Employee');//Get Employee Dropdown list

        getMasterKeywordList("Activity")
        getMasterKeywordList("Project")
        getMasterKeywordList("Currency")
        getMasterKeywordList("unit")
        getMasterKeywordList("Ingredient")
        getMasterKeywordList("Service")
        getMasterKeywordList("PO")
        // this.getCurrencyList()

        if (type != 'edit') {
            this.props.fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);//Fetch subordinate api list
        }

        if (type === 'edit') {
            this.props.getRequestAttributeData(this.props.match.params.id);
        }

        const clearTimer = () => clearInterval(interval);
        const interval = setInterval(() => {
            const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
            const requestId = this.props.match.params.id || this.state.requestId;
            const { tableLists, containerData } = this.props;
            const type = this.props.match.params.type;
            let requestattachments = tableLists.requestattachments || [];
            this.setState({ requestattachments });

            const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
            let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
            if (type === 'edit') {
                process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
            }

            if (process && !this.props.loading) {
                this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                clearTimer();
            }
        }, 300);

    }


    render() {
        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
        const actionRowStyle = { display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' };

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
        const dialogDynamicFooter = (
            <div style={actionRowStyle}>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary" />
            </div>
        );
        let a;
        {
            a = process.filter((p, i) => i <= parseInt(stageSequence));
        }


        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Purchase Return
                            <Link to={'/purchasereturn'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>



                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');

                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title" style={{ width: '100%', boxSizing: 'border-box' }}>
                            <h1>{description}</h1>
                            <div className="p-grid" style={{ width: '100%', margin: '0', boxSizing: 'border-box' }}>
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const rowFields = containerGroup[row].reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(rowFields);
                                        return tableRow;
                                    }, []) || [];

                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"} style={{ boxSizing: 'border-box' }}>
                                        {field.fieldType != "9" ? <Inputs
                                            field={field}
                                            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
                                            process={process}
                                            onInputChange={(e) => this.handleChange(e, field)}
                                            {...this.props}
                                            {...this.state}
                                            metaData={{
                                                ...this.props.metaData,
                                                'Party Name': this.state.partyType === 'Vendor'
                                                    ? (this.props.Vendor || [])
                                                    : (this.props.Outlet || [])
                                            }} /> :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? true : this.state[field.fieldName]} onToggle={(e) => this.setState({ [field.fieldName]: e.value })} style={{ border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)', width: '100%', maxWidth: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
                                                    <div className="p-grid" style={{ width: '100%', marginLeft: 0, marginRight: 0, paddingLeft: '0.5rem', paddingRight: '0.5rem', boxSizing: 'border-box', maxWidth: '100%' }}>
                                                        {containerFields.map((subField, subIndex) => <div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"} style={{ boxSizing: 'border-box', maxWidth: '100%' }}><Inputs
                                                            field={subField}
                                                            value={subField.fieldType === '3' ? (Array.isArray(subField.fieldValue) ? subField.fieldValue : (typeof subField.fieldValue === 'string' && subField.fieldValue ? subField.fieldValue.split(",").filter(v => v) : [])) : subField.fieldValue}
                                                            process={process}
                                                            onInputChange={(e) => this.handleChange(e, subField)}
                                                            {...this.props}
                                                            {...this.state} /></div>)}
                                                        <div className="p-col-12 p-md-6 p-lg-4" style={{ boxSizing: 'border-box', maxWidth: '100%' }}>
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={() => this.setState({ editing: false })} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={() => this.setState({ editing: false })} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                            </div>}
                                                        </div>
                                                        <div className="p-col-12" style={{ boxSizing: 'border-box', width: '100%' }}>
                                                            <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
                                                                <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                                    // expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                                    // rowExpansionTemplate={this.rowExpansionTemplate} 
                                                                    editMode="cell"
                                                                    onCellEditComplete={this.onCellEditComplete}

                                                                    dataKey="childRowNmbr" rows={10} value={containerTable} style={{ minWidth: '100%' }}>

                                                                    <Column expander={true} style={{ width: '3em' }} />
                                                                    {containerFields.map((columnField, columnIndex) =>
                                                                        (columnField.fieldDescription === 'Activity') ? <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} editor={this.textEditor} body={(rowData) => this.activityNameRender(rowData, columnField)} /> : <Column key={columnIndex} field={columnField.fieldDescription.replace(' ', '_')} header={columnField.fieldDescription} />
                                                                    )}
                                                                    {
                                                                        ((pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                    }
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {(stage.stageNum == '000' || stage.stageSequence == 0) ?
                                    <div className="p-col-12 p-md-12 p-lg-12">
                                        {/* <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VehiclePass'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     />  */}
                                    </div>
                                    :
                                    null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/purchasereturn'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :

                                    <div className="p-col-12 p-md-12 p-lg-12" style={actionRowStyle}>
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary" label="Save" icon="pi pi-save" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger" label="Cancel" onClick={() => this.saveRequest('cancel')} />
                                        <Button onClick={() => this.generatePayslip('download')} className="p-button-success" label="Download PDF" icon="pi pi-file-pdf" />
                                        {/* <Button onClick={() => this.generatePayslip('view')} className="p-button-success ml1" label="View Payslip" icon="pi pi-save" /> */}
                                        <Link to={'/purchasereturn'}>
                                            <Button className="p-button-secondary" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );
    }







}

const mapStateToProps = (state, props) => {
    const pageType = props.match.params.type;
    const subordinatesList = pageType === 'edit' && state.master.requestAttributeData ? ([Object.assign({}, { label: `${state.master.requestAttributeData.employeename} (Self)`, value: state.master.requestAttributeData.employeeID })]).concat(state.master.subordinatesListData) : ([Object.assign({}, { label: `${state.auth.userObject.userName} (Self)`, value: state.auth.userObject.empID, userId: state.auth.userObject.userID })]).concat(state.master.subordinatesListData);
    const emplist = state?.master?.keywordValuesList?.map(e => ({ ...e, value: e.uniqueId })) || []
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesListData = state.master.subordinatesListData;
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, { ...el }, { value: el.uniqueId }));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID, id: parseInt(state.auth.userObject.userID) })]);

    let relevantOptions = [];
    const hrTeam = parseInt(localStorage.getItem('hrTeam'));
    if (hrTeam) {
        relevantOptions = Employee.reduce((a, el) => {
            if (el.value !== loggedUserDetail.empID) {
                a.push(el);
            }
            return a;
        }, [Object.assign({}, Employee.find(list => list.value === loggedUserDetail.empID), { label: 'Self', id: loggedUserDetail.userID })]);
    } else {
        relevantOptions = (loggedUserDetail !== null) ? [{ label: `${loggedUserDetail.userName}(Self)`, value: loggedUserDetail.empID, id: loggedUserDetail.userID }].concat(subordinatesListData) : subordinatesListData;
    }
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        Employee,
        EmployeeList: relevantOptions,
        currencyList: state.keyword.Currency || [],
        keywordValuesList,
        Vendor: state.keyword.Vendor || [],
        Outlet: state.keyword.Customer || [],
        metaData: Object.assign({}, {
            'Employees': subordinatesList,
            'Requested For': subordinatesList,
            'Employee Id': emplist,
            // "Requested For": relevantOptions,
            "Nationality": state.keyword.nationality,
            "Currency": state.keyword.Currency || [],
            'Project': state.keyword.Project,
            'Unit': state.keyword.unit,
            'Name': state.keyword.Ingredient,
            "Party Type": PartyType || [],
            "Purchase Order": state.keyword.PO || [],
            "Service": state.keyword.Service || [],
            // "Party Name": PartyType === 'Vendor' ? state.keyword.Vendor : PartyType === '' ? state.keyword.Customer : [],
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddPurchaseReturn);